// Entry point for theme scripts
// Typescript compiles to static/site.js
import FilterToggleHandler from "./FilterToggleHandler";
import FootnoteHoverHandler from "./FootnoteHoverHandler";
import LightboxNavigationHandler from "./LightboxNavigationHandler";
import OverviewHandler from "./OverviewHandler";
import ScrollRevealHandler from "./ScrollRevealHandler";
import ScrollToTopHandler from "./ScrollToTopHandler";
import ScrollbarHandler from "./ScrollbarHandler";
import FluidCanvas from "./fluidCanvas";

const ready = (fn: () => void) => {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

ready(() => {
  // Example: toggle class on body when JS is active
  document.body.classList.add("js-enabled");

  // Initialize FluidCanvas asynchronously (non-blocking)
  const fluidCanvas = new FluidCanvas();

  const overviewHandler = new OverviewHandler();

  // Initialize lightbox navigation to preserve canvas state
  const lightboxNavigation = new LightboxNavigationHandler();

  // Initialize scroll to top button
  const scrollToTop = new ScrollToTopHandler();

  // Initialize overlay scrollbar indicator
  const scrollbar = new ScrollbarHandler();

  // Initialize filter toggle for sortIndex page
  const filterToggle = new FilterToggleHandler();

  // Initialize footnote hover tooltips
  const footnoteHover = new FootnoteHoverHandler();

  // Initialize scroll reveal animations for articles
  const scrollReveal = new ScrollRevealHandler();

  const handleCanvasPause = () => {
    const isSingleMode =
      document.body.classList.contains("single") ||
      document.querySelector(".lightbox-article.open") !== null;

    if (isSingleMode) {
      fluidCanvas.pause();
    } else {
      fluidCanvas.resume();
    }
  };

  // Initialize canvas and handle initial pause logic
  fluidCanvas
    .init()
    .then(() => {
      console.log("FluidCanvas initialized");

      // If we started on a single page, run simulation ticks immediately then pause
      if (document.body.classList.contains("single")) {
        console.log("Starting on single page - running initial simulation");

        // Run simulation ticks immediately to position items
        // This ensures items are positioned even if images load quickly (e.g., from CDN cache)
        fluidCanvas.runSimulationTicks(150); // ~5 seconds worth of physics at 30fps

        // Wait for at least 5 images to load before rendering and pausing
        window.addEventListener(
          "fluidCanvasImagesLoaded",
          () => {
            console.log("Images loaded - forcing render then pausing canvas");
            // Force a render to ensure textures are drawn
            fluidCanvas.forceRender();
            // Now pause
            fluidCanvas.pause();
          },
          { once: true }
        ); // Only listen once
      }
    })
    .catch((error) => {
      console.error("Failed to initialize FluidCanvas:", error);
    });

  // Listen for lightbox state changes
  window.addEventListener("lightboxContentLoaded", handleCanvasPause);
  window.addEventListener("popstate", handleCanvasPause);

  // Watch for body class changes
  const observer = new MutationObserver(handleCanvasPause);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
  });
});
